const PlayerActionTypes = {
  SET_CURRENT_TRACK: 'SET_CURRENT_TRACK',
  PLAY_TRACK: 'PLAY_TRACK',
  PAUSE_TRACK: 'PAUSE_TRACK',
  STOP_TRACK: 'STOP_TRACK',
  RESUME_TRACK: 'RESUME_TRACK',
  SET_CURRENT_TRACKLIST: 'SET_CURRENT_TRACKLIST',
  SET_UNAVAILABLE_TRACK: 'SET_UNAVAILABLE_TRACK'
};
export default PlayerActionTypes;
